// src/pages/meeting/FinancialApprovalPage.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";
import MeetingInvitationENForm from "../../forms/meeting/MeetingInvitationEN/MeetingInvitationEN";

function MeetingInvitationENPage() {
  return (
    <FormWrapper
  title="Invitationmeeting"
  FormComponent={MeetingInvitationENForm}
  formKey="meeting-invitation-en"
/>

  );
  }

export default MeetingInvitationENPage;
